import { M as MapyReviewStars$1, d as defineCustomElement$1 } from './mapy-review-stars2.js';

const MapyReviewStars = MapyReviewStars$1;
const defineCustomElement = defineCustomElement$1;

export { MapyReviewStars, defineCustomElement };

//# sourceMappingURL=mapy-review-stars.js.map